import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  getTeamsList: createThunk('parents/getTeamsList', (values) =>
    api.get(WEB_API_ROUTES.team.list, {
      params: { ...values },
    })
  ),

  createMember: createThunk('parents/createMember', (data) =>
    api.post(WEB_API_ROUTES.team.list, data)
  ),

  getEmployees: createThunk('parents/getEmployees', ({ employeesId }) =>
    api.get(WEB_API_ROUTES.team.info.replace('{employeesId}', employeesId))
  ),

  editEmployees: createThunk('parents/editEmployees', ({ employeesId, data }) =>
    api.post(
      WEB_API_ROUTES.team.info.replace('{employeesId}', employeesId),
      data
    )
  ),

  removeEmployeesAvatar: createThunk(
    'parents/removeEmployeesAvatar',
    (employeesId) =>
      api.delete(
        WEB_API_ROUTES.team.removeEmployeesAvatar.replace(
          '{employeesId}',
          employeesId
        )
      )
  ),

  deleteTeamMember: createThunk('parents/deleteTeamMember', (employeesId) =>
    api.delete(WEB_API_ROUTES.team.info.replace('{employeesId}', employeesId))
  ),
};
